/* Kinnup — product page: option picker, 1/2/3 tiers with a size per unit, gallery */
(function () {
  'use strict';

  function money(cents, format) {
    var fmt = format || '${{amount}}';
    function group(dec, th, d) {
      var p = (cents / 100).toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.length > 1 ? p.join(d) : p[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, t) {
      if (t === 'amount_no_decimals') return group(0, ',', '.');
      if (t === 'amount_with_comma_separator') return group(2, '.', ',');
      if (t === 'amount_no_decimals_with_comma_separator') return group(0, '.', ',');
      return group(2, ',', '.');
    });
  }

  function json(root, sel) {
    var el = root.querySelector(sel);
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }

  function findVariant(variants, values) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < values.length; j++) if (variants[i].options[j] !== values[j]) { ok = false; break; }
      if (ok) return variants[i];
    }
    return null;
  }

  function initProduct(root) {
    var variants = json(root, '[data-kn-variants]');
    var options = json(root, '[data-kn-options]') || [];
    if (!variants) return;
    var format = root.getAttribute('data-kn-money-format');
    var idInput = root.querySelector('[data-kn-id]');
    var priceEl = root.querySelector('[data-kn-price]');
    var wasEl = root.querySelector('[data-kn-was]');
    var submit = root.querySelector('[data-kn-submit]');
    var form = root.querySelector('form[action*="/cart/add"]');
    var optsBox = root.querySelector('[data-kn-opts]');
    var unitsBox = root.querySelector('[data-kn-units]');
    var tier = 1;

    function current() {
      var values = [];
      for (var i = 0; i < options.length; i++) {
        var c = root.querySelector('input[name="kn-opt-' + i + '"]:checked');
        values.push(c ? c.value : null);
      }
      return values;
    }

    function apply() {
      var values = current();
      var v = findVariant(variants, values);
      values.forEach(function (val, i) { var s = root.querySelector('[data-kn-sel="' + i + '"]'); if (s) s.textContent = val; });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl && tier === 1) priceEl.textContent = money(v.price, format);
      if (wasEl) wasEl.hidden = !(v.compare_at_price > v.price);
      if (submit) submit.disabled = !v.available;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.featured_media) document.dispatchEvent(new CustomEvent('kn:media', { detail: { id: v.featured_media.id } }));
    }

    // one row per unit: a select for every option, so the Duo can be Youth + Adult
    function buildUnits(n) {
      if (!unitsBox) return;
      var base = current();
      var html = '';
      for (var u = 0; u < n; u++) {
        html += '<div class="kn-unit"><div>#' + (u + 1) + '</div>';
        options.forEach(function (name, i) {
          var vals = [];
          variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
          var pick = base[i];
          if (name === 'Size' && u > 0 && vals.length > 1) pick = vals[(vals.indexOf(base[i]) + u) % vals.length];
          html += '<select aria-label="' + name + ' for #' + (u + 1) + '" data-kn-unit-opt="' + i + '">' +
            vals.map(function (x) { return '<option' + (x === pick ? ' selected' : '') + '>' + x + '</option>'; }).join('') + '</select>';
        });
        html += '</div>';
      }
      unitsBox.innerHTML = html;
    }

    function setTier(n) {
      tier = n;
      var r = root.querySelector('input[name="kn-tier"][value="' + n + '"]');
      if (r) r.checked = true;
      if (optsBox) optsBox.hidden = n > 1;
      if (unitsBox) { unitsBox.hidden = n === 1; if (n > 1) buildUnits(n); }
      var label = r ? r.nextElementSibling.querySelector('strong') : null;
      if (priceEl) {
        if (n > 1 && label) { priceEl.textContent = label.firstChild.textContent.trim(); }
        else { var cv = findVariant(variants, current()) || variants[0]; priceEl.textContent = money(cv.price, format); }
      }
      if (wasEl) wasEl.hidden = n > 1;
    }

    root.addEventListener('change', function (e) {
      if (e.target.name && e.target.name.indexOf('kn-opt-') === 0) apply();
      if (e.target.name === 'kn-tier') setTier(parseInt(e.target.value, 10));
    });

    if (form) form.addEventListener('submit', function (e) {
      if (tier === 1) return; // theme AJAX form + drawer handles a single item
      e.preventDefault();
      e.stopImmediatePropagation();
      var counts = {};
      unitsBox.querySelectorAll('.kn-unit').forEach(function (row) {
        var vals = [];
        row.querySelectorAll('select').forEach(function (s) { vals[parseInt(s.getAttribute('data-kn-unit-opt'), 10)] = s.value; });
        var v = findVariant(variants, vals);
        if (v) counts[v.id] = (counts[v.id] || 0) + 1;
      });
      var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      submit.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function () {
        submit.disabled = false;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') { drawer.show(); } else { window.location.href = '/cart'; }
      }).catch(function () { submit.disabled = false; window.location.href = '/cart'; });
    }, true);

    // phones: a buy bar slides up once the real button has scrolled away above the viewport
    var bar = root.querySelector('[data-kn-sticky]');
    if (bar && submit) {
      var shown = null, tick = false;
      var check = function () {
        tick = false;
        var on = submit.getBoundingClientRect().bottom < 0;
        if (on === shown) return;
        shown = on;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelectorAll('a, button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      };
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', check);
      check();
      var add = bar.querySelector('[data-kn-sticky-add]');
      if (add) add.addEventListener('click', function () { submit.click(); });
      var sp = bar.querySelector('[data-kn-sticky-price]');
      if (sp && priceEl) new MutationObserver(function () { sp.textContent = priceEl.textContent; }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    // quantity stepper (non-hero products): 1–20, minus greys out at 1
    var qty = root.querySelector('[data-kn-qty] input');
    if (qty) {
      var minus = root.querySelector('[data-kn-step="-1"]');
      var plus = root.querySelector('[data-kn-step="1"]');
      var setQty = function (n) {
        n = Math.max(1, Math.min(20, parseInt(n, 10) || 1));
        qty.value = n;
        if (minus) minus.disabled = n <= 1;
        if (plus) plus.disabled = n >= 20;
      };
      root.querySelectorAll('[data-kn-step]').forEach(function (b) {
        b.addEventListener('click', function () { setQty((parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-kn-step'), 10)); });
      });
      qty.addEventListener('change', function () { setQty(qty.value); });
      setQty(qty.value);
    }

    var q = parseInt(new URL(window.location.href).searchParams.get('qty') || '1', 10);
    if (q === 2 || q === 3) setTier(q);
  }

  function initSlider(root) {
    var track = root.querySelector('.kn-slider__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call((root.parentNode || document).querySelectorAll('[data-kn-dot]'));
    var prev = root.querySelector('[data-kn-prev]');
    var next = root.querySelector('[data-kn-next]');
    function idx() { var w = track.clientWidth || 1; return Math.round(track.scrollLeft / w); }
    function sync() {
      var i = idx();
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    function go(i, instant) { track.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * track.clientWidth, behavior: instant ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    document.addEventListener('kn:media', function (e) {
      slides.forEach(function (s, n) { if (String(s.getAttribute('data-kn-media-id')) === String(e.detail.id)) go(n, true); });
    });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); });
    window.addEventListener('resize', sync);
    sync();
  }


  // before / after: rotates on its own, tabs jump, pauses on hover
  function initBA(root) {
    var slides = root.querySelectorAll('.kn-ba__slide');
    var tabs = root.querySelectorAll('[data-kn-ba-go]');
    var i = 0, timer = null;
    function show(n) {
      i = n;
      slides.forEach(function (s) { s.style.transform = 'translateX(' + (-100 * i) + '%)'; });
      tabs.forEach(function (b, k) { b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function start() { stop(); timer = setInterval(function () { show((i + 1) % slides.length); }, 3500); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    tabs.forEach(function (b) { b.addEventListener('click', function () { show(parseInt(b.getAttribute('data-kn-ba-go'), 10)); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }

  // buy-box reviews: one card at a time, swipe or wait; stops once the visitor touches it
  function initRQ(root) {
    var cards = root.querySelectorAll('.kn-rq__card');
    if (cards.length < 2) return;
    var i = 0, timer = null, x0 = null;
    function show(n) {
      i = (n + cards.length) % cards.length;
      cards.forEach(function (c) { c.style.transform = 'translateX(' + (-100 * i) + '%)'; });
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('touchstart', function (e) { stop(); x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
    });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-kn-rq-next]')) { stop(); show(i + 1); } });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { show(i + 1); }, 5500);
  }

  // in-page CTA links (#kn-buy, #family, #catalog): the base theme swallows anchor clicks
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.kn a[href^="#"]') : null;
    if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    e.stopPropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  function boot() {
    document.querySelectorAll('[data-kn-product]').forEach(initProduct);
    document.querySelectorAll('[data-kn-slider]').forEach(initSlider);
    document.querySelectorAll('[data-kn-ba]').forEach(initBA);
    document.querySelectorAll('[data-kn-rq]').forEach(initRQ);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
